import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import APIError from 'types/api_error';

import { useAPI } from 'hooks/api/useAPI';
import { useMutationWithError } from 'hooks/api/useMutationWithError';

export function useRestartGateway({
  onMutate,
  onSettled,
  ...options
}: UseMutationOptions<void, APIError, string> = {}) {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutationWithError(api.gateways.cloud.restart, {
    ...options,
    action: 'restart',
    entity: 'gateway',
    async onMutate(gatewayId) {
      await queryClient.cancelQueries(['gateways']);
      await queryClient.cancelQueries(['gateway', gatewayId]);

      onMutate?.(gatewayId);
    },
    onSettled(data, error, gatewayId, ...args) {
      onSettled?.(data, error, gatewayId, ...args);

      queryClient.invalidateQueries(['gateways']);
      queryClient.invalidateQueries(['gateway', gatewayId]);
    },
  });
}
